module.exports = __webpack_public_path__ + "static/media/check.046c7b6a.png";